import { useCallback } from 'react';
import { t } from 'i18next';
import { AppMedError } from '../error/AppMedError';
import { EmailErrorCode } from '../types/EmailErrorTypes';

export interface EmailErrorInfo {
    title: string;
    message: string;
    isEmailError: boolean;
    errorCode?: EmailErrorCode;
    emailAddress?: string;
}

export const useEmailErrorHandler = () => {
    const handleEmailError = useCallback((error: AppMedError): EmailErrorInfo | null => {
        // Check if this is an email validation error (HTTP 422)
        if (error.httpStatusCode === 422 && error.errorCode) {
            switch (error.errorCode) {
                case EmailErrorCode.EMAIL_ADDRESS_UNUSABLE:
                    return {
                        title: t('emailErrors.unusableTitle'),
                        message: t('emailErrors.unusableMessage', { email: error.contextData?.EmailAddress }),
                        isEmailError: true,
                        errorCode: EmailErrorCode.EMAIL_ADDRESS_UNUSABLE,
                        emailAddress: error.contextData?.EmailAddress as string
                    };
                
                case EmailErrorCode.EMAIL_TEMPORARILY_UNAVAILABLE:
                    return {
                        title: t('emailErrors.temporarilyUnavailableTitle'),
                        message: t('emailErrors.temporarilyUnavailable', { email: error.contextData?.EmailAddress }),
                        isEmailError: true,
                        errorCode: EmailErrorCode.EMAIL_TEMPORARILY_UNAVAILABLE,
                        emailAddress: error.contextData?.EmailAddress as string
                    };
                
                default:
                    break;
            }
        }
        
        return null;
    }, []);

    return { handleEmailError };
}; 